import { Carousel } from "../componentes/CreadorPaginas/componentes/Carousel";
import Botones from "../componentes/CreadorPaginas/componentes/Botones";
import TextoEnriquecido from "../componentes/CreadorPaginas/componentes/TextoEnriquecido";
import Titulos from "../componentes/CreadorPaginas/componentes/Titulos";
import EspaciadorVertical from "../componentes/CreadorPaginas/componentes/EspaciadorVertical";
import BotonImagen from "../componentes/CreadorPaginas/componentes/BotonImagen";
import IconoTexto from "../componentes/CreadorPaginas/componentes/IconoTexto";
import MenuNavegacion from "../componentes/CreadorPaginas/componentes/MenuNavegacion";
import Formulario from "../componentes/CreadorPaginas/componentes/Formulario";
import Mapa from "../componentes/CreadorPaginas/componentes/Mapa";
import Image from "../componentes/CreadorPaginas/componentes/Image";
import BannerSecundario from "../componentes/CreadorPaginas/componentes/BannerSecundario";
import Footer from "../componentes/CreadorPaginas/componentes/Footer";
import Tienda from "../componentes/CreadorPaginas/componentes/Tienda";
import BannerPaginaIndividual from "../componentes/CreadorPaginas/componentes/BannerPaginaIndividual";
import Producto from "../componentes/CreadorPaginas/componentes/Producto";
import DetalleFacturacion from "../componentes/CreadorPaginas/componentes/DetalleFacturacion";
import SeguimientoPedido from "../componentes/CreadorPaginas/componentes/SeguimientoPedido";
import VerificarPago from "../componentes/CreadorPaginas/componentes/VerificarPago";
import Galeria from "../componentes/CreadorPaginas/componentes/Galeria";
import Login from "../componentes/CreadorPaginas/componentes/Login";
import Perfil from "../componentes/CreadorPaginas/componentes/Perfil";
import Tarjeta1 from "../componentes/CreadorPaginas/componentes/Tarjeta1";

export const campos = [
    {
        type: "carousel",
        title: "Carousel"
    },
    {
        type: "button",
        title: "Botón"
    },
    {
        type: "texto",
        title: "Texto Enriquecido"
    },
    {
        type: "titulo",
        title: "Titulo"
    },
    {
        type: "espaciadorVertical",
        title: "Espaciador Vertical"
    },
    {
        type: "botonImagen",
        title: "Boton Imagen"
    },
    {
        type: "iconoTexto",
        title: "Icono Texto"
    },
    {
        type: "menuNavegacion",
        title: "Menu"
    },
    {
        type: "formulario",
        title: "Formulario"
    },
    {
        type: "mapa",
        title: "Mapa"
    },
    {
        type: "imagen",
        title: "Imagen"
    },
    {
        type: "bannerSecundario",
        title: "Banner Secundario"
    },
    {
        type: "footer",
        title: "Footer"
    },
    {
        type: "tienda",
        title: "Tienda"
    },
    {
        type: "bannerPaginaIndividual",
        title: "Banner Pagina Individual"
    },
    {
        type: "producto",
        title: "Producto"
    },
    {
        type: "detalleFacturacion",
        title: "Detalle de Facturación"
    },
    {
        type: "seguimientoPedido",
        title: "Seguimiento de Pedido"
    },
    {
        type: "verificarPago",
        title: "Verificar Pago"
    },
    {
        type: "galeria",
        title: "Galeria de Imagenes"
    }, {
        type: "login",
        title: "Iniciar Sesion"
    }, {
        type: "perfil",
        title: "Perfil"
    },
    {
        type: "tarjeta1",
        title: "Tarjeta 1"
    }
];

// These define how we render the field
export const renderizarCampos = {
    carousel: Carousel,
    texto: TextoEnriquecido,
    button: Botones,
    titulo: Titulos,
    espaciadorVertical: EspaciadorVertical,
    botonImagen: BotonImagen,
    iconoTexto: IconoTexto,
    menuNavegacion: MenuNavegacion,
    formulario: Formulario,
    mapa: Mapa,
    imagen: Image,
    bannerSecundario: BannerSecundario,
    footer: Footer,
    tienda: Tienda,
    bannerPaginaIndividual: BannerPaginaIndividual,
    producto: Producto,
    detalleFacturacion: DetalleFacturacion,
    seguimientoPedido: SeguimientoPedido,
    verificarPago: VerificarPago,
    galeria: Galeria,
    login: Login,
    perfil: Perfil,
    tarjeta1: Tarjeta1
};
